import { render, staticRenderFns } from "./s-code.vue?vue&type=template&id=3726cee8&scoped=true&"
import script from "./s-code.vue?vue&type=script&lang=js&"
export * from "./s-code.vue?vue&type=script&lang=js&"
import style0 from "./s-code.vue?vue&type=style&index=0&id=3726cee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3726cee8",
  null
  
)

export default component.exports